import React from 'react'

export default function Checkmark(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0.73 2.64 19.05 13.71" stroke="#747894" {...props}>
    <path d="M18.25 4.16663L7.58333 14.8333L2.25 9.49996" strokeWidth="3.04762" strokeLinejoin="round"/>
  </svg>
}
